import nhp from '../dist/index.js'

export const CommentNode = nhp.CommentNode;
export const HTMLElement = nhp.HTMLElement;
export const parse = nhp.parse;
export const valid = nhp.valid;
export const Node = nhp.Node;
export const TextNode = nhp.TextNode;
export const NodeType = nhp.NodeType;

export default nhp;